import { useRef } from 'react'

/**
 * When calling an async function that changes the state of the component, the async response
 * may be received after another call to the async function has been made. Only the last call
 * should be preserved, and the previous calls should be ignored.
 */
export function useNonConcurrentPromiseProxy () {
  const currentPromiseRef = useRef<Promise<any> | null>(null)

  return function<T> (promise: Promise<T>) {
    currentPromiseRef.current = promise

    return new Promise<T>((resolve, reject) => {
      promise
        // If no the last promise, dismiss the result to prevent state override in caller component.
        .then(arg => { if (currentPromiseRef.current === promise) resolve(arg) })
        .catch(reject)
    })
  }
}
